<div class="qw-modal-content" *ngIf="modalToggle" [@modalBodyEnterExit]="modalToggle">
  <ng-content></ng-content>
</div>